
import Vue from "vue";

export default Vue.extend({
  name: "SuccessfulSubmit",

  props: {
    value: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data: () => ({
    model: false as boolean,
    logo: require("@/assets/images/usmf-logo.png"),
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.model = this.value;
      },
    },
  },

  methods: {
    toggle() {
      this.model = !this.model;
    },
    reload() {
      this.toggle();
      location.reload();
    },
  },
});
